<section class="flex h-full w-full flex-col overflow-hidden bg-white text-slate-900" role="dialog" aria-labelledby="channel-group-title">
  <header class="flex shrink-0 items-center gap-3 border-b !border-slate-100 px-4 py-3">
    <h2 id="channel-group-title" class="!m-0 min-w-0 flex-1 !text-base !font-bold !leading-6">
      {{ (group ? 'chat_settings.edit_channel_group' : 'chat_settings.create_channel_group') | translate }}
    </h2>
    <app-button btnType="icon" [ariaLabel]="'close' | translate" [disabled]="saving" (onChangeClick)="requestClose()">
      <app-icon>close</app-icon>
    </app-button>
  </header>

  <div class="crm-scroll flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4">
    @if (loading) {
      <div class="flex flex-1 items-center justify-center" role="status" [attr.aria-label]="'loading' | translate">
        <app-loader size="small" />
      </div>
    } @else if (loadError) {
      <div role="alert" class="flex flex-col items-start gap-3 text-red-600">
        <p>{{ 'chat_settings.group_error' | translate }}</p>
        <app-button (onChangeClick)="load()">{{ 'chat_settings.retry' | translate }}</app-button>
      </div>
    } @else {
      @if (saveError) {
        <p role="alert" class="text-red-600">{{ 'chat_settings.group_error' | translate }}</p>
      }
      <app-input [label]="'name' | translate" [formControl]="form.controls.name" [required]="true" [disabled]="saving" />
      <app-select
        [label]="'choose_channel' | translate"
        optionLabel="name"
        optionValue="id"
        [type]="SelectType.Multiple"
        [options]="availableChannels"
        [isImg]="true"
        [formControl]="form.controls.channel_ids"
        [disabled]="saving"
        [filter]="true"
        [showToggleAll]="true"
        [showClear]="true"
      />
      <p class="!m-0 text-sm text-slate-500">{{ 'chat_settings.available_channels_hint' | translate }}</p>
      <app-select
        [label]="'chat_settings.group_responsible' | translate"
        optionLabel="name"
        optionValue="id"
        [type]="SelectType.Multiple"
        [options]="responsibleOptions"
        optionDisabled="disabled"
        [maxSelectedLabels]="employees.length"
        [showToggleAll]="false"
        [formControl]="form.controls.responsible_ids"
        [disabled]="saving"
        [isAvatar]="true"
        [filter]="true"
        [showClear]="true"
      />
      <app-checkbox [formControl]="form.controls.distribute_chats" [disabled]="saving">
        {{ 'chat_settings.round_robin' | translate }}
      </app-checkbox>
      @if (form.controls.distribute_chats.value) {
        <app-select
          [label]="'chat_settings.distribution_participants' | translate"
          optionLabel="name"
          optionValue="id"
          [type]="SelectType.Multiple"
          [options]="distributionOptions"
          optionDisabled="disabled"
          [maxSelectedLabels]="employees.length"
          [showToggleAll]="false"
          [formControl]="form.controls.distribution_user_ids"
          [disabled]="saving"
          [isAvatar]="true"
          [filter]="true"
          [showClear]="true"
        />
        <p class="!m-0 text-sm text-slate-500">{{ 'chat_settings.distribution_visibility_hint' | translate }}</p>
      }
    }
  </div>

  <footer class="flex shrink-0 gap-2 border-t !border-slate-100 px-4 py-3">
    <app-button btnType="stroked" class="flex-1" customClass="w-full !h-10 !rounded-lg" [disabled]="saving" (onChangeClick)="requestClose()">
      {{ 'cancel' | translate }}
    </app-button>
    <app-button class="flex-1" customClass="w-full !h-10 !rounded-lg" [disabled]="loading || loadError || saving" (onChangeClick)="save()">
      {{ (saving ? 'saving' : 'save') | translate }}
    </app-button>
  </footer>
</section>
